import isEmpty from "lodash-es/isEmpty";

import { Track } from "@/api/models/track";
import { NetworkSignal, networkSignal } from "@/utils/signals";
import { createStore } from "@/utils/store";
import { addToQueryString } from "@/utils/url";
import { Store } from "@/store";
import { initApi } from "@/utils";

type State = {
  selectedTrackId: Track["id"] | undefined;
};

type NetworkState = {
  introContent: NetworkSignal<string>;
  trackContent: NetworkSignal<string>;
};

type Slices = {};

type Actions = {
  setSelectedTrack: (trackId: Track["id"]) => void;
  fetchTrackContent: (trackId?: Track["id"]) => void;
  fetchIntroContent: () => Promise<string | undefined>;
};

export type ProjectContentSlice = ReturnType<typeof createContentSlice>;

export function createContentSlice() {
  return createStore<State, NetworkState, Actions, Slices>({
    initialState: {
      selectedTrackId: undefined,
    },
    networkState: {
      trackContent: networkSignal<string>(),
      introContent: networkSignal<string>(),
    },
    slices: () => ({}),
    actions: ({ store, networkState }) => {
      return {
        setSelectedTrack: trackId => {
          if (isEmpty(trackId) || trackId === store.selectedTrackId.value) {
            return;
          }

          store.selectedTrackId.value = trackId;
          addToQueryString("track", trackId!);

          import("@/services/analyticsService").then(({ useAnalyticsService }) => {
            useAnalyticsService().trackProjectTrackSelected(Store.project.id.value!, trackId);
          });
        },
        fetchTrackContent: (trackId?: Track["id"]) => {
          const projectId = Store.project.id.value;
          const selectedTrackId = trackId ?? store.selectedTrackId.value;

          if (projectId == null || isEmpty(selectedTrackId)) {
            return;
          }

          const api = initApi();
          networkState.trackContent.run(async () => {
            networkState.trackContent.signal.data.value = undefined;
            return await api.getProjectFile({ id: projectId, filename: selectedTrackId! });
          });
        },
        fetchIntroContent: async () => {
          const projectId = Store.project.id.value;

          if (isEmpty(projectId)) {
            return;
          }

          const api = initApi();
          return networkState.introContent.run(async () => {
            networkState.introContent.signal.data.value = undefined;
            return await api.getProjectFile({ id: projectId!, filename: "intro" });
          });
        },
      };
    },
  });
}
